/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementDefinition } from './MeasurementDefinition';
/**
 * 
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Language
     */
    name?: string | null;
    /**
     * 
     * @type {Array<MeasurementDefinition>}
     * @memberof Language
     */
    measurementDefinitions?: Array<MeasurementDefinition> | null;
}

/**
 * Check if a given object implements the Language interface.
 */
export function instanceOfLanguage(value: object): value is Language {
    return true;
}

export function LanguageFromJSON(json: any): Language {
    return LanguageFromJSONTyped(json, false);
}

export function LanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Language {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'measurementDefinitions': json['measurementDefinitions'] == null ? undefined : ((json['measurementDefinitions'] as Array<any>).map((require('./MeasurementDefinition') as typeof import('./MeasurementDefinition')).MeasurementDefinitionFromJSON)),
    };
}

export function LanguageToJSON(json: any): Language {
    return LanguageToJSONTyped(json, false);
}

export function LanguageToJSONTyped(value?: Language | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'measurementDefinitions': value['measurementDefinitions'] == null ? undefined : ((value['measurementDefinitions'] as Array<any>).map((require('./MeasurementDefinition') as typeof import('./MeasurementDefinition')).MeasurementDefinitionToJSON)),
    };
}

